import { render, staticRenderFns } from "./TextAlignCenterIcon.vue?vue&type=template&id=b31131b2&"
import script from "./TextAlignCenterIcon.vue?vue&type=script&lang=js&"
export * from "./TextAlignCenterIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports